<script>
function toggle() {
	window.document.body.classList.toggle('dark-mode')
}
</script>
<button on:click={toggle}>
	<slot/>
</button>

<img src='/img/logo.png' alt='Logo'>

<style>
	button {
    position: fixed;
    left: 0;
    bottom: 0;
    margin-left: 5%;
    margin-bottom: 12%;
		padding-top: 10px;
		padding-bottom:10px;
		padding-left:10px;
		padding-right:0px;
		background-color: transparent;
		color: white;
		border: none;
    padding: 0;
		text-transform: uppercase;
    font-family: monospace;
    cursor: crosshair;
		z-index: 10;
	}

	:global(body.dark-mode) button {
		background-color: transparent;
		color: black;
	}

	img {
		position: fixed;
		top: 0;
		left: 0;
		margin: 3%;
		width: 75px;
		height: 75px;
		filter: invert(0);
	}

	:global(body.dark-mode) img {
		filter: invert(1);
	}
</style>
